export const BASE_URL = 'https://store.crashstickers.com/';
export const GREEN_CARD_OCR_URL =
  'https://us-central1-crashstickers.cloudfunctions.net/greenCardOCR';
export const STRIPE_KEY = 'pk_live_AxNeCJ2HiSIZY0aU3pobW5eI';



// WEBPACK FOOTER //
// ./src/assets/constants.js